// keywordscore 전체 공식 (2차 가공 공식)
export const keywordScoreFormulaBase = {
  searchScore: (trafficScore: number): number => {
    return Math.round(trafficScore * 10);
  },
  diffScore: (difficultyScore: number): number => {
    return Math.round(difficultyScore * 10);
  },
  chanceScore: (difficultyScore: number) => {
    return ((100 - difficultyScore) * keywordScoreFormulaBase.searchScoreWeight(difficultyScore)) / 100;
  },

  /**
   * @description searchScore 가중치 함수 (스코어에 따른 가중치 %)
   * @param score
   */
  searchScoreWeight: (score) => {
    if (score <= 10) {
      return 1;
    } else if (score <= 20) {
      return 0.9;
    } else if (score <= 30) {
      return 0.8;
    } else if (score <= 40) {
      return 0.7;
    } else if (score <= 50) {
      return 0.6;
    } else if (score <= 60) {
      return 0.5;
    } else if (score <= 70) {
      return 0.4;
    } else if (score <= 80) {
      return 0.3;
    } else if (score <= 90) {
      return 0.2;
    } else if (score <= 100) {
      return 0.1;
    }
  },
};
